import authorization from './authorization';
import mainService from './mainService';
import binance from './binance';
import notifications from './notifications';
import buddy from './buddy';
import v2 from './v2';
import screener from './screener';
export default {
    authorization,
    mainService,
    binance,
    notifications,
    buddy,
    v2,
    screener
};
